import { BRAND, THEMES } from "../../config/constants";

export default function StatusProgress({status,theme}){
  const steps=["Engagement Sent","Signed","Tax Return in Progress","Submitted","Paid","Completed"];
  const cur=steps.indexOf(status);
  return <div style={{display:"flex",gap:3}}>{steps.map((s,i)=><div key={s} style={{flex:1,height:4,borderRadius:2,background:i<=cur?(i===cur?BRAND.blue:BRAND.green):THEMES[theme].border,opacity:i<cur?0.6:1}}/>)}</div>;
}
